/*
使用方法：
1.main.js中注册
import toastRegistry from './components/common/toast/index'   ////toast弹窗组件
Vue.use(toastRegistry)    ////挂到原型链上

2,直接使用
this.$toast('我是toast弹窗')
*/
import Vue from 'vue'
import vm from '@/main' ///导入VUE实例

// 这里就是我们刚刚创建的那个静态组件
import toastComponent from './public-control-toast.vue'
import { publicFadeInOut } from 'common/tool'

// 返回一个 扩展实例构造器
const ToastConstructor = Vue.extend(toastComponent)
let toastDom = {}
// 定义弹出组件的函数 接收2个参数, 要显示的文本 和 显示时间
function showToast(type, objData) {
  // 实例化一个 toast.Vue
  toastDom = new ToastConstructor({
    el: document.createElement('div'),
    data() {
      return {
        toastState: {
          ///淡入淡出的控制
          click: true,
          fade: true
        },
        type: type,
        objData: objData
        // showWrap: true, // 是否显示组件
        // showContent: true // 作用:在隐藏组件之前,显示隐藏动画
      }
    },
    methods: {
      ///这里把二级页面消息事件句柄放在了index.js中，这样销毁不会出现问题
      upadataoneObjData(oneObjData) {
        console.log('当前打开的二级页面数据发生了改变')
        console.log(oneObjData)
        this.objData = oneObjData.detail.data
      }
    }
  })

  // 把 实例化的 toast.Vue 添加到 body 里
  document.body.appendChild(toastDom.$el)
}

///////////控制关闭toast的的函数
function closeToastDom() {
  //根据需要，销毁事件 当前打开的二级页面数据发生了改变 监听
  console.log('二级页面control2PageUpdata事件销毁')
  ///这里把二级页面消息事件句柄放在了index.js中，这样销毁不会出现问题
  window.removeEventListener('control2PageUpdata', toastDom.upadataoneObjData)
  vm.$store.dispatch('asyUpdataobjData', {}) ///异步清空数据，用于二级页面的实时状态更新 20200405添加
  publicFadeInOut(toastDom.toastState, 400) ///淡出的时间控制，详见函数说明
}

// 注册为全局组件的函数
function showControlToast() {
  // 将组件注册到 Vue 的 原型链里去,
  // 这样就可以在所有 Vue 的实例里面使用 this.$toast()
  Vue.prototype.$showControlToast = showToast ///控制显示toast的函数
}
function closeControlToast() {
  // 将组件注册到 Vue 的 原型链里去,
  Vue.prototype.$closeControlToast = closeToastDom ///////////控制关闭toast的的函数
}

export { showControlToast, closeControlToast }
